"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedfragrance = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 41 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedfragrance` : '') + (description ? ` desc-brandedfragrance` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedfragrance"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedfragrance"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.998 5H22.998V7H29.998V5Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.8821 2.00024H17.114C16.7718 2.00024 16.498 2.27399 16.498 2.61617V9.00024H23.498V2.61617C23.498 2.27399 23.2243 2.00024 22.8821 2.00024Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.5 12.7327C7.87326 12.7327 0 20.6969 0 30.7327C0 41.5002 7.88317 48.7327 19.5 48.7327C31.1168 48.7327 38.9982 40.9354 38.9982 31.0002C38.9982 21.065 31.2455 12.7327 19.5 12.7327Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.998 5.5C40.998 8.53243 36.466 11 32.6001 11C28.7342 11 26.998 8.54234 26.998 5.5C26.998 2.45766 28.7342 0 32.6001 0C36.466 0 40.998 2.45766 40.998 5.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.498 5.71027C18.498 4.6091 17.6895 3.70557 16.6853 3.70557C16.6172 3.70557 16.5576 3.72439 16.498 3.72439V7.68674C16.5576 7.68674 16.6257 7.70557 16.6853 7.70557C17.681 7.70557 18.498 6.81145 18.498 5.70086V5.71027Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.255 9H13.7508C13.3402 9 12.998 9.37946 12.998 9.85938V14H26.998V9.85938C26.998 9.39063 26.6656 9 26.2452 9H26.255Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.4927 48.6859C31.4124 48.6859 39.2651 40.6633 39.2651 30.7801C39.2651 25.6085 37.0961 20.967 33.3505 17.6959C24.5639 26.9989 14.4316 34.9615 3.26511 41.3536C6.68938 45.815 12.3931 48.6959 19.4827 48.6959L19.4927 48.6859Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedfragrance;